import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useLocation } from "@remix-run/react";

const BranchDisplay = ({ gitBranch }) => {
  const [shouldShow, setShouldShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentUrl = window.location.href;

      const blockList = ["coschool", "beta"];

      const isBlocked = blockList.some((item) => currentUrl.includes(item));

      setShouldShow(!isBlocked);
    }
  }, [location]);

  if (!shouldShow) return null;

  return (
    <Box position="fixed" right={0} bottom={0}>
      Current Branch : {gitBranch}
    </Box>
  );
};

export default BranchDisplay;
